/* session/types */
import * as t from "io-ts";

function tOptional<T extends t.Mixed>(typeThing: T) {
  return t.union([t.undefined, typeThing]);
}
const tId = t.union([t.null, t.string]);

const ErrorCodec = t.type({
  code: t.string,
  detail: t.string,
  title: t.string,
});

const MetaCodec = t.type({
  token: t.string,
});

const AttributeCodec = t.intersection([
  t.type({
    Email: t.string,
    Enabled: t.boolean,
    FirstName: t.string,
    Group: t.string,
  }),
  t.partial({
    TempPassword: t.boolean,
    LastName: tOptional(t.string),
    PreferredName: tOptional(t.string),
    Company: tOptional(t.string),
    Department: tOptional(t.string),
    Phone: tOptional(t.string),
    LastLogin: tOptional(t.string),
  }),
]);
const AccessType = t.type({
  Collection: t.string,
  Create: t.boolean,
  Delete: t.boolean,
  Update: t.boolean,
});

const DataCodec = t.intersection([
  t.type({
    id: tId,
    type: t.string,
    attributes: AttributeCodec,
  }),
  t.partial({
    createdAt: t.string,
    updatedAt: t.string,
  }),
]);

export type Data = t.TypeOf<typeof DataCodec>;
export const SessionCodec = t.type({
  errors: tOptional(t.array(ErrorCodec)),
  data: tOptional(t.array(DataCodec)),
  meta: tOptional(MetaCodec),
  dirty: tOptional(t.boolean),
  second: tOptional(t.array(DataCodec)),
  permission: tOptional(t.any),
});

export type Session = t.TypeOf<typeof SessionCodec>;

export enum SessionActionTypes {
  FETCH = "@@session/FETCH",
  SECOND_FETCH = "@@session/SECOND_FETCH",
  FETCH_SUCCESS = "@@session/FETCH_SUCCESS",
  SECOND_FETCH_SUCCESS = "@@session/SECOND_FETCH_SUCCESS",
  FETCH_ERROR = "@@session/FETCH_ERROR",
  DIRTY = "@@session/DIRTY",
  CLEAR_STORAGE = "@@session/CLEAR_STORAGE",
  SET_SESSION = "@@session/SET_SESSION",
  UN_DIRTY = "@@session/UN_DIRTY",
  LOGOUT_REQUEST = "@@session/LOGOUT_REQUEST",
  LOGOUT_SUCCESS = "@@session/LOGOUT_SUCCESS",
  LOGOUT_ERROR = "@@session/LOGOUT_ERROR",
}

export interface SessionState {
  readonly loading: boolean;
  readonly data: Session | null;
  readonly errors?: string;
  readonly dirty: boolean;
  readonly isSecondUser?: boolean;
  readonly second: any;
}

export type AccessType = t.TypeOf<typeof AccessType>;
export type AccessMap = {
  [Collection: string]: AccessType;
};
